/* eslint-disable react/prop-types */ // TODO: add props
import styles from './styles.scss';

const Cross = ({ selected, onClick, disabled }) => {
  if (selected) {
    return (
      <div
        className={styles.option}
        data-test="checklist-cross-selected"
        data-testid="checklist-cross-selected"
      >
        <span className={styles.crossSelected} />
      </div>
    );
  }

  return (
    <div
      className={styles.option}
      onClick={!disabled ? onClick : null}
      data-test="checklist-cross"
      data-testid="checklist-cross"
      role="button"
    >
      <span className={styles.cross} />
    </div>
  );
};

Cross.defaultProps = {
  selected: true,
  disabled: false,
};

export default Cross;
